import {
  Button,
  CircularProgress,
  useMediaQuery,
  useTheme,
} from "@material-ui/core"
import PropTypes from "prop-types"
import { React, useContext } from "react"
import HoverText from "~/components/Common/HoverText"
import ClientContext from "~/contexts/Client"

import Box from "~/components/Common/Box"
import PermissionsWrapper from "~/components/Common/PermissionsWrapper"
import useStyles from "./styles"

const ClientHeader = ({ client }) => {
  const classes = useStyles()
  const { debouncedDetails, updateClientFunc, loading } =
    useContext(ClientContext)
  const theme = useTheme()

  const mdDown = useMediaQuery(theme.breakpoints.down("md"))
  const smDown = useMediaQuery(theme.breakpoints.down("sm"))

  const nameSize = smDown ? 30 : mdDown ? 40 : 50

  const handleSave = () => {
    updateClientFunc()
  }

  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="space-evenly"
      position="relative"
      width="100%"
      className={classes.headerContainer}
    >
      <Box display="flex" justifyContent="space-between" flexWrap="wrap">
        <Box marginLeft="16px">
          <HoverText
            data={
              debouncedDetails?.name !== ""
                ? debouncedDetails?.name
                : client?.name
            }
            variant="h1"
            className={classes.title}
            size={nameSize}
          />
        </Box>
        <Box
          marginRight="16px"
          marginLeft="16px"
          className={classes.saveContainer}
        >
          <PermissionsWrapper permissionGroup="admin">
            <Button
              variant="contained"
              size="small"
              color="primary"
              onClick={handleSave}
              className={classes.saveBtn}
            >
              {loading ? (
                <Box height="20px" width="30px">
                  <CircularProgress size={10} style={{ color: "#fff" }} />
                </Box>
              ) : (
                "Save"
              )}
            </Button>
          </PermissionsWrapper>
        </Box>
      </Box>
    </Box>
  )
}

ClientHeader.propTypes = {
  client: PropTypes.object,
}

export default ClientHeader
